<template>
    <PageView>
        <a-spin :spinning="loading">
            <a-card :title="uid ? `编辑小程序` : `添加小程序`">
                <a-form :form="form" style="width:700px">
                    <a-form-item label="小程序名称" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            v-decorator="['name', { rules: [{ required: true, message: '请输入小程序名称' }] }]"
                            placeholder="请输入小程序名称"
                        />
                    </a-form-item>

                    <a-form-item label="APPID" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            v-decorator="['app_id', { rules: [{ required: true, message: '请输入APPID' }] }]"
                            placeholder="请输入APPID"
                        />
                    </a-form-item>

                    <a-form-item label="数据源" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            v-decorator="['code', { rules: [{ required: true, message: '请输入数据源' }] }]"
                            placeholder="请输入数据源"
                        />
                    </a-form-item>

                    <a-form-item label="AES_KEY" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            v-decorator="['aes_key', { rules: [{ required: true, message: '请输入AES_KEY' }] }]"
                            placeholder="请输入AES_KEY"
                        />
                    </a-form-item>

                    <a-form-item label="版本号" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            v-decorator="['version', { rules: [{ required: false, message: '请输入版本号' }] }]"
                            placeholder="请输入版本号"
                        />
                    </a-form-item>

                    <a-form-item label="是否开启外链" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-radio-group v-model="is_open_url">
                            <a-radio :value="1">关闭</a-radio>
                            <a-radio :value="2">开启</a-radio>
                        </a-radio-group>
                    </a-form-item>

                    <a-form-item label="是否全局跳转" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-radio-group v-model="is_jump_global">
                            <a-radio :value="1">只点击跳转</a-radio>
                            <a-radio :value="2">全局跳转</a-radio>
                            <a-radio :value="3">内页跳转</a-radio>
                        </a-radio-group>
                    </a-form-item>

                    <a-form-item label="是否开启H5跳转" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-radio-group v-model="is_h5_jump">
                            <a-radio :value="1">关闭</a-radio>
                            <a-radio :value="2">开启</a-radio>
                        </a-radio-group>
                    </a-form-item>

                    <a-form-item label="上下架状态" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-radio-group v-model="is_off">
                            <a-radio :value="1">下架</a-radio>
                            <a-radio :value="2">上架</a-radio>
                        </a-radio-group>
                    </a-form-item>

                    <a-form-item label="跳转地址" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-textarea
                            v-decorator="['jump_url', { rules: [{ required: true, message: '请输入跳转地址' }] }]"
                            placeholder="请输入跳转地址"
                            :rows="4"
                        />
                    </a-form-item>

                    <a-form-item label="首页界面" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-radio-group v-model="is_jietu">
                            <a-radio :value="1">正常</a-radio>
                            <a-radio :value="2">截图</a-radio>
                            <a-radio :value="3">额度测算</a-radio>
                            <a-radio :value="4">计算器</a-radio>
                            <a-radio :value="5">比价</a-radio>
                            <a-radio :value="6">租超(拿手机号)</a-radio>
                            <a-radio :value="7">租超(直跳)</a-radio>
                            <a-radio :value="8">会展服务</a-radio>
                            <a-radio :value="9">3C数码维修</a-radio>
                            <a-radio :value="10">租机资讯</a-radio>
                            <a-radio :value="11">网页嵌套</a-radio>
                            <a-radio :value="12">宝宝起名</a-radio>
                            <a-radio :value="13">个税计算神器</a-radio>
                            <a-radio :value="14">退休金计算神器</a-radio>
                            <a-radio :value="15">菜谱大全</a-radio>
                            <a-radio :value="16">开销记账神器</a-radio>
                            <a-radio :value="17">手机查询神器</a-radio>
                        </a-radio-group>
                    </a-form-item>

                    <a-form-item label="首页界面标识" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            v-decorator="['jietu_img', { rules: [{ required: false, message: '请输入首页截图标识' }] }]"
                            placeholder="首页截图标识"
                        />
                    </a-form-item>

                    <a-form-item label="登录账号" :label-col="labelCol" :wrapper-col="wrapperCol" v-if="!uid">
                        <a-input
                            v-decorator="['loginname', { rules: [{ required: true, message: '请输入登录账号' }] }]"
                            placeholder="请输入登录账号"
                        />
                    </a-form-item>
                    <a-form-item label="密码" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            type="password"
                            v-decorator="['loginpwd', { rules: [{ required: true, message: '请输入密码' }] }]"
                            placeholder="请输入密码"
                        />
                    </a-form-item>
                    <a-form-item label="重复密码" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            type="password"
                            v-decorator="['loginpass', { rules: [{ required: true, message: '请输入重复密码' }] }]"
                            placeholder="请输入重复密码"
                        />
                    </a-form-item>
                    <a-form-item label="手机号" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            v-decorator="['phone', { rules: [{ required: true, message: '请输入手机号' }] }]"
                            placeholder="请输入手机号"
                        />
                    </a-form-item>

                    <a-form-item label="首页模版样式" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            v-decorator="['temple_code', { rules: [{ required: false, message: '样式模版' }] }]"
                            placeholder="目前有:3tu|4tu|5tu|5tu2"
                        />
                    </a-form-item>

                    <a-form-item label="主体名称" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            v-decorator="['shop_name', { rules: [{ required: false, message: '请输入支付宝主体名称' }] }]"
                            placeholder="请输入支付宝主体名称"
                        />
                    </a-form-item>

                    <a-form-item label="主体账号" :label-col="labelCol" :wrapper-col="wrapperCol">
                        <a-input
                            v-decorator="['shop_account', { rules: [{ required: false, message: '请输入支付宝主体账号' }] }]"
                            placeholder="请输入支付宝主体账号"
                        />
                    </a-form-item>

                </a-form>
                <a-button type="primary" @click="sub">
                    {{ uid ? '修改' : '新增' }}
                </a-button>
                <a-button type="primary" @click="$router.back()" style="margin-left:10px">
                    返回
                </a-button>
            </a-card>
        </a-spin>
    </PageView>
</template>
<script type="text/jsx">
import moment from 'moment'
import Shop from '../../api/Shop.js'
import Home from '../../api/Home.js'
export default {
    name: 'addMember',
    data () {
        return {
            form:this.$form.createForm(this),
            loading: true,
            labelCol: {
                xs: { span: 2 },
                sm: { span: 4 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 }
            },
            addone: [],
            addtwo: [],
            addthree: [],
            searchData: {
                pro_id: undefined,
                city_id: undefined,
                area_id: undefined,
            },
            packageType:'',
            is_open_url:'',
            is_jump_global:'',
            is_h5_jump:'',
            is_off:'',
            pic: '',
            is_jietu:'',
            jietu_img:'',
            version: '',
            is_robot_checking: 1,
            is_jietu_punish: 99,
            uid:this.$route.query.id || undefined,
        }
    },
    activated () {
        Shop.AreaList({
            parent_id: 100000
        }).then(res => {
            this.addone = res.result
            this.loading = false
            this.form.resetFields()
            this.searchData.pro_id = undefined
            this.searchData.city_id = undefined
            this.searchData.area_id = undefined
            if(this.uid)this.getPerson()
        })
    },

    methods: {
        moment,
        handleChange (e) {
            let file = e.target.files[0]
            let reader = new FileReader()
            reader.onload = () => {
                Home.upload({ img: reader.result }).then(res => {
                    this.pic = res.result
                })
                reader.onload = true;
            }
            reader.readAsDataURL(file)
        },
        getaddone (id) {
            Shop.AreaList({
                parent_id: id
            }).then(res => {
                this.addtwo = res.result
            })
        },
        getaddtwo (id) {
            Shop.AreaList({
                parent_id: id
            }).then(res => {
                this.addthree = res.result
            })
        },
        // 修改用
        getPerson () {
            this.uid = this.$route.query.id;
            this.loading = true
            Shop.Findprovider({ id: this.uid }).then(res => {
                let data = res.result
                this.$nextTick(() => {
                    this.form.setFieldsValue({
                        'bili': data.bili,
                        'add_ress': data.add_ress,
                        'name': data.name,
                        'phone': data.phone,
                        'loginpwd': data.pass,
                        'loginpass': data.pass,
                        'app_id': data.app_id,
                        'code': data.code,
                        'aes_key': data.aes_key,
                        'is_open_url': data.is_open_url,
                        'is_jump_global': data.is_jump_global,
                        'is_h5_jump': data.is_h5_jump,
                        'is_off': data.is_off,
                        'is_jietu': data.is_jietu,
                        'jietu_img': data.jietu_img,
                        'jump_url': data.jump_url,
                        'temple_code': data.temple_code,
                        'shop_name': data.shop_name,
                        'shop_account': data.shop_account,
                        'version': data.version,
                    })
                    // this.searchData.pro_id = data.pro_id.toString()
                    this.searchData.pro_id = data.pro_id
                    // this.getaddone(this.searchData.pro_id)
                    // this.searchData.city_id = data.city_id.toString()
                    this.searchData.city_id = data.city_id
                    // this.getaddtwo(this.searchData.city_id)
                    this.searchData.area_id = data.area_id
                    this.packageType = data.type
                    this.is_open_url = data.is_open_url
                    this.is_jump_global = data.is_jump_global
                    this.is_h5_jump = data.is_h5_jump
                    this.is_off = data.is_off
                    this.is_jietu = data.is_jietu
                    this.jietu_img = data.jietu_img
                    this.version = data.version
                    this.is_robot_checking = data.is_robot_checking || 1
                    this.is_jietu_punish = data.is_jietu_punish || 99
                    // this.searchData.area_id = data.area_id.toString()
                    this.loading = false;
                })
            })
        },
        sub () {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.loading = true
                    if(this.uid){
                        Shop.Saveprovider({ id:this.uid,...values, ...this.searchData,type:this.packageType,is_open_url:this.is_open_url,is_jump_global:this.is_jump_global,is_h5_jump:this.is_h5_jump, is_off:this.is_off,is_jietu:this.is_jietu, jietu_img: this.jietu_img, version: this.version, is_robot_checking: this.is_robot_checking, is_jietu_punish: this.is_jietu_punish}).then(res => {
                            this.loading = false

                            this.$router.back()
                            this.form.resetFields()
                        }).catch(res => {
                            this.loading = false
                        })
                    }else{
                        Shop.Addprovider({ ...values, ...this.searchData,type:this.packageType,is_open_url:this.is_open_url,is_jump_global:this.is_jump_global,is_h5_jump:this.is_h5_jump,is_off:this.is_off,is_jietu:this.is_jietu, jietu_img: this.jietu_img, version: this.version, is_robot_checking: this.is_robot_checking, is_jietu_punish: this.is_jietu_punish}).then(res => {
                            this.loading = false
                            this.$router.back()
                            this.form.resetFields()
                        }).catch(res => {
                            this.loading = false
                        })
                    }
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
.imgContaienr {
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 15px;

    .con {
        height: 300px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            display: block;
            max-height: 100%;
            max-width: 100%;
        }

        .placeText {
            font-size: 20px;
        }
    }
}

.btnCon {
    position: relative;
    overflow: hidden;
    display: inline-block;

    input {
        display: block;
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        background: red;
        opacity: 0;
    }
}

.map {
    width: 900px;
    height: 500px;
}

#tip {
    background-color: #fff;
    border: 1px solid #ccc;
    padding-left: 10px;
    padding-right: 2px;
    position: absolute;
    min-height: 65px;
    top: 10px;
    font-size: 12px;
    right: 10px;
    border-radius: 3px;
    overflow: hidden;
    line-height: 20px;
    min-width: 30%;
}

#tip input[type='button'] {
    background-color: #0d9bf2;
    height: 25px;
    width: 500px;
    text-align: center;
    line-height: 25px;
    color: #fff;
    font-size: 12px;
    border-radius: 3px;
    outline: none;
    border: 0;
    cursor: pointer;
}

#tip input[type='text'] {
    height: 25px;
    border: 1px solid #ccc;
    padding-left: 5px;
    border-radius: 3px;
    outline: none;
}
</style>
